import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade, Controller } from 'swiper/modules';
import GLightbox from "glightbox";

document.addEventListener("DOMContentLoaded", function (event) {

    // INIT MENUBUTTON
    const menu_button = document.querySelector('[data-behaviour="toggle-menu"]');
    menu_button.addEventListener('click', () => {
        document.body.classList.toggle('body--show');
    })

    // INIT LIGHTBOX
    const lightbox = GLightbox({
        selector: '[data-gallery="gallery"]',
        touchNavigation: true,
        loop: true,
    });

    // INIT SWIPER
    const sliders = document.querySelectorAll('.swiper');
    sliders.forEach(function (slider) {
        const autoSwiper = slider.classList.contains('swiper--auto');
        const swiper = new Swiper(slider, {
            // configure Swiper to use modules
            modules: [Pagination, Navigation, Autoplay, EffectFade],
            effect: 'slide',
            fadeEffect: {
                crossFade: true
            },
            direction: 'horizontal',
            loop: true,

            autoplay: autoSwiper ? {
                delay: 5000,
            } : false,

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            draggable: false,

            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
        });
    });

    // MOBILE TILE TOGGLE
    const mobileToggles = document.querySelectorAll('.section_mobile-toggle');
    mobileToggles.forEach(function (toggle) {
        toggle.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            const tile = toggle.closest('.tile');

            // Toggle active class on current tile
            tile.classList.toggle('tile--active');

            // Optional: Close other open tiles
            // Uncomment if you want only one tile open at a time
            // const allTiles = document.querySelectorAll('.tile');
            // allTiles.forEach(function(otherTile) {
            //     if (otherTile !== tile) {
            //         otherTile.classList.remove('tile--active');
            //     }
            // });
        }, true);
    });

    // TILE POPUP MODAL
    const popupTiles = document.querySelectorAll('.tile--popup');
    if (popupTiles.length) {
        const modal = document.createElement('dialog');
        modal.className = 'tile-modal';
        modal.innerHTML = `
            <button type="button" class="tile-modal_close" aria-label="Schließen">&times;</button>
            <div class="tile-modal_content"></div>
        `;
        document.body.appendChild(modal);

        const modalContent = modal.querySelector('.tile-modal_content');

        const openModal = (html) => {
            modalContent.innerHTML = html;
            document.body.classList.add('body--modal-open');
            modal.showModal();
        };

        // Native dialog fires 'close' for Escape, the close button, and .close() alike
        modal.addEventListener('close', () => {
            document.body.classList.remove('body--modal-open');
        });

        // Click on the dialog's own backdrop area (not its content) closes it
        modal.addEventListener('click', (e) => {
            if (e.target === modal) modal.close();
        });

        modal.querySelector('.tile-modal_close').addEventListener('click', () => modal.close());

        popupTiles.forEach(function (tile) {
            const template = document.getElementById(tile.getAttribute('data-popup-target'));
            if (!template) return;

            const trigger = function (e) {
                e.preventDefault();
                openModal(template.innerHTML);
            };

            tile.addEventListener('click', trigger);
            tile.addEventListener('keydown', function (e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    trigger(e);
                }
            });
        });
    }

    // HERO VIDEO
    // Defer loading until the page has fully loaded and the browser is idle, so the
    // video does not delay the hero image (LCP). Skipped for reduced motion and data saver.
    const heroVideos = document.querySelectorAll('[data-behaviour="hero-video"]');
    const skipVideo = window.matchMedia('(prefers-reduced-motion: reduce)').matches
        || (navigator.connection && navigator.connection.saveData);
    if (heroVideos.length && !skipVideo) {
        const initHeroVideos = () => {
            heroVideos.forEach(function (video) {
                const toggle = video.parentElement.querySelector('[data-behaviour="hero-video-toggle"]');

                video.addEventListener('playing', () => {
                    video.classList.add('section_image_video--playing');
                    if (toggle) toggle.hidden = false;
                }, { once: true });

                if (toggle) {
                    toggle.addEventListener('click', () => {
                        if (video.paused) {
                            video.play();
                        } else {
                            video.pause();
                        }
                        const paused = video.paused;
                        toggle.classList.toggle('section_image_video-toggle--paused', paused);
                        toggle.setAttribute('aria-label', paused ? 'Video abspielen' : 'Video pausieren');
                    });
                }

                video.src = video.dataset.src;
                // Autoplay may be blocked; the image simply stays visible then
                video.play().catch(() => {});
            });
        };
        const scheduleInit = () => {
            if ('requestIdleCallback' in window) {
                requestIdleCallback(initHeroVideos, { timeout: 2000 });
            } else {
                setTimeout(initHeroVideos, 200);
            }
        };
        if (document.readyState === 'complete') {
            scheduleInit();
        } else {
            window.addEventListener('load', scheduleInit, { once: true });
        }
    }

    // FIXED HEADER
    window.addEventListener('scroll', () => {
        if (document.documentElement.scrollTop > 30 || document.body.scrollTop > 30){
            document.body.classList.add('menu--fixed');
        } else {
            document.body.classList.remove('menu--fixed');
        }
    });
});
